import TopContentBirthdayMessage from 'components/RwdBasket/RwdBasketLayout/TopContentMessages/TopContentBirthdayMessage/TopContentBirthdayMessage';
import { withBirthdayMessageProps } from 'viewModel/rwdBasket/birthdayMessage/withBirthdayMessageProps';

export default withBirthdayMessageProps(TopContentBirthdayMessage);
